export default "__VITE_ASSET__d3523a1b__"